"use client";

import IconTextCard from "@/components/pages/bus/cards/IconTextCard.jsx";
import DynamicStats from "@/components/DynamicStats.js";
import OpportunitiesCardWrapper from "@/components/OpportunitiesCardWrapper";

import { 
  CampaignCard, 
  IconText,
  PopularLocationCard,
} from "@/components/featured/common";

import { 
  RouteDealCard,
  BlogCard,
} from "@/components/featured/bus";

export const componentRegistry = {
  CampaignCard,
  PopularLocationCard,
  BlogCard,
  RouteDealCard,
  IconTextCard,
  IconText,
  DynamicStats,
  OpportunitiesCardWrapper,
};

export const itemPropMapping = {
  OpportunitiesCardWrapper: "stats",
  CampaignCard: "item",
  PopularLocationCard: "item",
  BlogCard: "post",
  RouteDealCard: "item",
  IconTextCard: "item",
  DynamicStats: "stats",
};
